export default __webpack_public_path__ + "static/media/salam-sample.ee299f7b.svg";